module.exports = __webpack_public_path__ + "img/index_titleButtom.50c15c46.png";